<template>
  <el-table-column
    prop="secondary_manufacturer.name"
    sortable="custom"
    label="Másodlagos gyártó"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.secondary_manufacturer">{{ scope.row.secondary_manufacturer.name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'secondary_manufacturer.name',
  };
</script>
